class BrandAwardsToggle {
  constructor() {
    this.init();
  }

  getElementHeight(el) {
    const rect = el.getBoundingClientRect();
    const heightWithPadding = rect.height;
    const styles = window.getComputedStyle(el);

    return heightWithPadding + parseInt(styles.marginBottom);
  }

  handle() {
    const brandAwardsEl = document.querySelector('[data-brand-awards]');

    if (brandAwardsEl && window.innerWidth >= 992) {
      const brandAwardsItems = document.querySelectorAll('[data-brand-awards-item]');

      if (brandAwardsItems.length > 3) {
        const awardsSectionEl = document.querySelector('[data-brand-and-bottle-awards]');
        const firstThreeHeight =
          this.getElementHeight(brandAwardsItems[0]) +
          this.getElementHeight(brandAwardsItems[1]) +
          this.getElementHeight(brandAwardsItems[2]);

        const brandAwardsShowMoreEl = document.querySelector('[data-brand-awards-show-more]');
        const brandAwardsList = document.querySelector('[data-brand-awards-list]');
        const awardsSectionHeight = this.getElementHeight(awardsSectionEl);

        brandAwardsList.setAttribute('aria-expanded', 'false');
        brandAwardsList.style.maxHeight = `${firstThreeHeight}px`;
        brandAwardsEl.style.opacity = '1';

        const clickHandler = (e) => {
          e.preventDefault();

          const isExpanded = brandAwardsList.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            brandAwardsList.style.maxHeight = `${firstThreeHeight}px`;
            brandAwardsList.setAttribute('aria-expanded', 'false');
            brandAwardsShowMoreEl.innerText = `Show ${brandAwardsItems.length - 3} more`;
            brandAwardsEl.style.height = `${firstThreeHeight}px`;
            awardsSectionEl.style.height = `${awardsSectionHeight}px`;
          } else {
            brandAwardsList.style.maxHeight = 'none';
            brandAwardsEl.style.height = 'auto';
            awardsSectionEl.style.height = 'auto';
            brandAwardsList.setAttribute('aria-expanded', 'true');
            brandAwardsShowMoreEl.innerText = 'Show less';
          }
        };

        brandAwardsShowMoreEl.addEventListener('click', clickHandler);
      }
    } else if (brandAwardsEl) {
      brandAwardsEl.style.opacity = '1';
      const brandAwardsList = document.querySelector('[data-brand-awards-list]');
      brandAwardsList.style.maxHeight = 'none';
    }
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => this.handle());
  }
}

new BrandAwardsToggle();
